import { useState } from "react";
import {
  Camera, ShieldCheck, Sparkles, Network, Rocket, ScanLine, GitMerge,
  CalendarCheck, CreditCard, ScrollText, UserCheck, PlugZap, ChevronDown, Activity,
} from "lucide-react";

const cardShadow = { boxShadow: "0 1px 4px rgba(0,0,0,0.07), 0 4px 16px rgba(0,0,0,0.05)" };

const ITEMS = [
  {
    icon: CalendarCheck,
    color: "blue",
    title: "Интеграция с YClients",
    tagline: "Готово · 2.0.0",
    description:
      "ScanApp работает вместе с YClients: на точке видны записи на день, пациент находится по " +
      "телефону и привязывается к своей записи, а ссылка на отчёт сама попадает в карточку " +
      "клиента в YClients.",
    points: [
      "Вкладка «Журнал» с записями YClients в виде календаря",
      "Поиск пациента по телефону и обязательный выбор записи",
      "Ссылка на отчёт автоматически уходит в YClients",
    ],
  },
  {
    icon: CreditCard,
    color: "emerald",
    title: "Оплата и списание товаров в YClients",
    tagline: "Готово · 2.2.0",
    description:
      "После обследования рекомендованные товары списываются, а визит оплачивается прямо из " +
      "ScanApp. Каталог товаров YClients обновляется для всех точек каждую ночь.",
    points: [
      "Оплата визита: услуга и товары одной операцией",
      "Окно «Перед сохранением»: мессенджер, категория записи, товары",
      "Ночное обновление каталога товаров из YClients",
    ],
  },
  {
    icon: Camera,
    color: "blue",
    title: "Подключение камер",
    tagline: "Готово · 2.7.0",
    description:
      "Камера подключена прямо к ScanApp: снимок делается внутри приложения и сразу сохраняется " +
      "в карточку обследования. Фотографии можно просматривать, удалять и добавлять к уже " +
      "сохранённым сканам.",
    points: [
      "Съёмка без переключения между приложениями",
      "Фото сразу привязано к пациенту и обследованию",
      "Очередь фотографий переживает сбой сети и повтор сохранения",
    ],
  },
  {
    icon: ShieldCheck,
    color: "emerald",
    title: "Надёжная синхронизация",
    tagline: "Готово · 2.8.0",
    description:
      "Сохранение данных и интеграция с YClients защищены от повторов, потери ответа и " +
      "конкурирующих изменений. Для каждой точки можно выпустить отдельный ключ и сразу отозвать " +
      "его без смены доступа у остальных филиалов.",
    points: [
      "Идемпотентное сохранение пациентов, сканов, фотографий и покупок",
      "Персистентная очередь списаний и оплат с ручной сверкой спорных операций",
      "Индивидуальные ключи точек и отзыв ранее выданных JWT",
    ],
  },
  {
    icon: ScrollText,
    color: "slate",
    title: "Логи точек и обязательные обновления",
    tagline: "Готово · 2.8.11",
    description:
      "Каждая точка ведёт журнал диагностики: сканер, YClients, связь, синхронизация, обновления. " +
      "Администратор центра видит проблемы точек на вкладке «Логи точек» и разбирает их без " +
      "выезда и удалённого доступа. Важные обновления ставятся обязательно.",
    points: [
      "Состояние всех точек за сутки на одном экране",
      "Обязательное обновление: «Установить сейчас» или «Через 10 минут»",
      "Номер версии виден внизу левого меню",
    ],
  },
  {
    icon: ScanLine,
    color: "blue",
    title: "Сканер «из коробки»",
    tagline: "Готово · 2.8.14",
    description:
      "Драйвер сканера и программа Plustek для связи с ним вшиты в установщик и ставятся без " +
      "интернета. Установка по ссылке делает чистую переустановку сканера, а программа сама " +
      "запускает агент и подключается к сканеру — нажимать «Подключить» не нужно.",
    points: [
      "Один установщик: программа, драйвер и SDK сканера",
      "Чистая переустановка сканера без AnyDesk и PowerShell",
      "Понятные сообщения об ошибках сканера и логи установки в админке",
    ],
  },
  {
    icon: GitMerge,
    color: "emerald",
    title: "Разбор конфликтов пациентов",
    tagline: "Готово · 2.8.14",
    description:
      "Администратор точки сам разбирает карточки, застрявшие с пометкой «конфликт изменений, " +
      "требуется проверка»: выбирает значения по полям или объединяет дубли одного пациента. " +
      "Перед изменениями сохраняется копия базы точки, обследования и покупки не теряются.",
    points: [
      "Выбор значения по каждому полю: на точке или на центре",
      "Объединение дублей с переносом обследований и покупок",
      "Испорченные символы в данных подсвечиваются и не выбираются по умолчанию",
    ],
  },
  {
    icon: ShieldCheck,
    color: "emerald",
    title: "Скан не теряется при смене пациента",
    tagline: "Готово · 2.8.14",
    description:
      "Если сотрудник выбирает другого пациента, пока скан не сохранён, программа спрашивает, " +
      "сохранить ли обследование у текущего пациента, и называет его по имени. Повторный скан " +
      "после сохранения сначала уточняет пациента, поэтому снимки больше не выбрасываются.",
    points: [
      "Одно окно подтверждения для всех способов сменить пациента",
      "Сохранение через обычное окно «Перед сохранением»",
      "Пациент уточняется до запуска сканера, а не после",
    ],
  },
  {
    icon: UserCheck,
    color: "blue",
    title: "Кто провёл обследование и псевдоним пациента",
    tagline: "Готово · 2.8.15",
    description:
      "На каждом обследовании сохраняется ФИО сотрудника, который его провёл. Пациенту можно " +
      "задать псевдоним: в отчёте печатается он, а не настоящее имя.",
    points: [
      "Колонка «Провёл» во всех списках обследований",
      "ФИО сотрудника с подсказками из сотрудников YClients",
      "Псевдоним в отчёте, настоящее имя — только в программе",
    ],
  },
  {
    icon: PlugZap,
    color: "emerald",
    title: "Сканер не отваливается после простоя",
    tagline: "Готово · 2.8.16",
    description:
      "Пока программа открыта, компьютер не засыпает, а установщик отключает энергосбережение " +
      "USB. Сканер больше не пропадает после перерыва, и его не нужно выключать и подключать " +
      "заново вместе с программой.",
    points: [
      "Компьютер не уходит в сон, пока открыта программа (экран гаснуть может)",
      "Энергосбережение USB отключается при каждой установке и обновлении",
      "Пробуждение компьютера видно в «Логах точек»",
    ],
  },
  {
    icon: Activity,
    color: "blue",
    title: "Сканер восстанавливается сам",
    tagline: "Готово · 2.8.17",
    description:
      "Если сканер пропал, программа сама переподключается, а зависшую программу сканера " +
      "перезапускает без перезапуска «ВсеСкан». Сканирование, прерванное обрывом, " +
      "повторяется само. В «Логах точек» видно, с какого компьютера работает точка.",
    points: [
      "Переподключение после сна и обрыва связи со сканером, проверка сканера раз в минуту",
      "Зависшая программа сканера перезапускается сама",
      "«Логи точек»: компьютер точки, последнее сканирование, выходы из сна",
    ],
  },
  {
    icon: ShieldCheck,
    color: "emerald",
    title: "Обследование не теряется, его путь виден",
    tagline: "Готово · 2.8.18",
    description:
      "Программа спрашивает «Сохранить?» при любом уходе с несохранённого скана — смене пациента, " +
      "«Очистить», «Выйти», закрытии программы, правках после сохранения. В «Логах точек» видно, " +
      "что стало с каждым обследованием: сохранено, отправлено на центр, принято, товары и оплата " +
      "в YClients — или удалено без сохранения.",
    points: [
      "«Сохранить?» при закрытии программы и выходе; автовыход ждёт сохранения",
      "История обследования и пациента — с точки и с центра, по времени",
      "Сводка: сохранено, удалено без сохранения, не отправлено на центр",
    ],
  },
  {
    icon: UserCheck,
    color: "blue",
    title: "Удобство обследований и сохранность данных",
    tagline: "Готово · 2.8.19",
    description:
      "Перед началом обследования программа просит заполнить псевдоним для отчёта и дату рождения. " +
      "Исправлены отметки жалоб, повторное сканирование и переключение дат в Журнале. " +
      "Окно «Перед сохранением» подставляет мессенджер и ссылку, уже записанные у пациента, — " +
      "повторное обследование больше не стирает их. В «Логах точек» у каждой точки светофор: " +
      "зелёный — всё в порядке, жёлтый — требует внимания, красный — не работает или теряет данные.",
    points: [
      "Псевдоним и дата рождения обязательны при входе в сканер; ФИО из карточки можно скопировать",
      "Новое обследование и пересканирование — отдельные понятные действия",
      "Обновление программы ждёт сохранения текущего обследования",
      "Ошибки видны с повтором запроса, сканер адаптируется к размеру окна",
      "Мессенджер постоянного пациента подставляется сам и не стирается пустым полем",
      "Светофор точки с причинами: нет связи, не отправлено, сканер, сон, старая версия",
    ],
  },
  {
    icon: Sparkles,
    color: "violet",
    title: "Нейросеть для анализа скана",
    tagline: "В планах",
    description:
      "Модель анализирует сам скан стопы и предлагает предварительные рекомендации — тип стопы, " +
      "зоны нагрузки, вероятные проблемные области — ещё до того, как специалист начнёт заполнять " +
      "жалобы вручную. Итоговое решение всегда остаётся за специалистом, нейросеть — черновик и " +
      "подсказка, а не диагноз.",
    points: [
      "Предварительный анализ сразу после сканирования",
      "Меньше рутинной ручной разметки для специалиста",
      "Более единообразные заключения между точками и сотрудниками",
    ],
  },
  {
    icon: Network,
    color: "slate",
    title: "Переход на микросервисы",
    tagline: "В планах",
    description:
      "Сейчас центр и точки работают на одном общем backend-приложении. По мере роста сети " +
      "(больше точек, больше нагрузки, больше интеграций вроде YClients) есть смысл разнести " +
      "самостоятельные части системы — синхронизацию, интеграции, обработку сканов — по отдельным " +
      "сервисам, чтобы они масштабировались и деплоились независимо друг от друга.",
    points: [
      "Отдельные части системы обновляются и масштабируются независимо",
      "Сбой в одной интеграции не затрагивает остальную систему",
      "Задел на рост числа точек и объёма данных",
    ],
  },
];

const COLOR_CLASSES = {
  blue: { bg: "bg-blue-50", text: "text-blue-600", ring: "ring-blue-100", dot: "bg-blue-500" },
  violet: { bg: "bg-violet-50", text: "text-violet-600", ring: "ring-violet-100", dot: "bg-violet-500" },
  emerald: { bg: "bg-emerald-50", text: "text-emerald-600", ring: "ring-emerald-100", dot: "bg-emerald-500" },
  slate: { bg: "bg-slate-100", text: "text-slate-600", ring: "ring-slate-200", dot: "bg-slate-400" },
};

const VERSIONS = [
  { version: "2.8.20", date: "04.11.2026", note: "обязательная", changes: [
    "Исправлено падение экрана обследования при неверном ответе справочников (map is not a function)",
    "Ошибка загрузки списков видна с кнопкой повтора; выбранные жалобы сохраняются",
  ] },
  { version: "2.8.19", date: "04.11.2026", note: "обязательная", changes: [
    "ВсеСкан: новое название, фирменный знак и иконки; исправлены масштаб и перемещение снимка",
    "Псевдоним и дата рождения до обследования; сохранение в два шага с предпросмотром стоп",
    "В отчёте — фактические цены, количество и сумма товаров; после сохранения — отчёт и следующий пациент",
    "Мессенджер не стирается при повторном обследовании; светофор состояния точек",
    "Исправлены пересканирование, жалобы, Журнал и повторы после ошибок; обновление ждёт сохранения",
  ] },
  { version: "2.8.18", date: "18.10.2026", note: "обязательная", changes: [
    "Несохранённое обследование не теряется: «Сохранить?» при закрытии программы, «Выйти», правках после сохранения; автовыход ждёт сохранения",
    "«Логи точек»: путь каждого обследования — сохранено, отправлено на центр, принято, товары и оплата в YClients, удалено без сохранения; история по обследованию и пациенту",
  ] },
  { version: "2.8.17", date: "18.10.2026", note: "обязательная", changes: [
    "Сканер сам переподключается после сна и обрыва, зависшая программа сканера перезапускается сама",
    "Сканирование, прерванное обрывом связи, повторяется автоматически; программа больше не зависает в «Сканирование…»",
    "«Логи точек»: компьютер точки, последнее сканирование, выходы из сна; меньше ложных ошибок",
  ] },
  { version: "2.8.16", date: "14.10.2026", note: "обязательная", changes: [
    "Компьютер не засыпает, пока открыта программа, — сканер не отваливается после перерыва",
    "Установщик отключает энергосбережение USB",
    "Roadmap: актуальные статусы и история версий",
  ] },
  { version: "2.8.15", date: "14.10.2026", note: "обязательная", changes: [
    "ФИО сотрудника в «Пользователях» и на каждом обследовании, колонка «Провёл» в списках",
    "Псевдоним пациента: печатается в отчёте вместо имени",
  ] },
  { version: "2.8.14", date: "08.10.2026", note: "обязательная", changes: [
    "Скан не теряется при смене пациента: одно окно «Сохранить текущее обследование?»",
    "Разбор конфликтов пациентов на точке: выбор значений по полям, объединение дублей",
    "Центр: привязка к YClients из карточки пациента",
    "Первая версия со встроенным драйвером сканера, пришедшая через автообновление",
  ] },
  { version: "2.8.12–2.8.13", note: "тестовые", changes: [
    "Драйвер и программы Plustek для сканера встроены в установщик, ставятся без интернета",
    "Установка по ссылке делает чистую переустановку сканера",
    "Программа сама запускает агент сканера и подключается к сканеру",
  ] },
  { version: "2.8.10–2.8.11", date: "03.10.2026", changes: [
    "Вкладка «Логи точек»: диагностика сканера, YClients, связи, синхронизации и обновлений",
    "Обязательные обновления и номер версии в меню",
    "Устранена причина окна «Не удалось закрыть VseStelki» при обновлении",
  ] },
  { version: "2.8.9", date: "29.09.2026", changes: ["Исправлено обновление VseStelki"] },
  { version: "2.8.8", date: "29.09.2026", changes: [
    "Журнал открывает карточку пациента на точке",
    "Понятная расшифровка статуса «несинхронизировано»",
  ] },
  { version: "2.8.7", date: "29.09.2026", changes: [
    "Новое постоянное имя программы — VseStelki, установка в один клик для всего компьютера",
    "Аварийная установка и очистка старых версий",
  ] },
  { version: "2.8.6", date: "25.09.2026", changes: [
    "Устранена блокировка обновлений: сервер точки работает внутри программы",
    "Пункт меню «Удалить старые версии» с сохранением данных",
  ] },
  { version: "2.8.5", date: "25.09.2026", changes: ["Разрешено подключение программы к агенту сканера WebScan2"] },
  { version: "2.8.4", date: "25.09.2026", changes: ["Установка в новый каталог"] },
  { version: "2.8.3", date: "25.09.2026", changes: ["Исправлена установка на Windows"] },
  { version: "2.8.2", date: "24.09.2026", changes: ["Исправлено обновление на Windows"] },
  { version: "2.8.1", date: "24.09.2026", changes: [
    "Журнал снова работает на точках со старыми версиями",
    "Точки переходят на HTTPS и отдельные ключи",
    "Исправлена сверка операций YClients",
  ] },
  { version: "2.8.0", date: "16.09.2026", changes: [
    "Надёжная синхронизация: повторы не создают дублей, фото и покупки не теряются без сети",
    "Очередь списаний и оплат YClients со сверкой спорных операций",
    "Отдельный ключ для каждой точки с возможностью отзыва",
  ] },
  { version: "2.7.0", date: "14.09.2026", changes: [
    "Камера в сканере и в сохранённых обследованиях, просмотр фото на весь экран",
    "Количество, цена и скидка у товаров",
    "Объединение каталога товаров, задублированного по точкам",
    "Исправлено списание товаров в YClients",
  ] },
  { version: "2.2.0", date: "18.08.2026", changes: [
    "Списание товаров и оплата визита в YClients",
    "Окно «Перед сохранением»: мессенджер, категория записи, автостатус «Пришёл»",
    "Ночное обновление каталога товаров YClients",
    "Повторное «Сохранить» больше не создаёт дубль обследования",
    "Страница Roadmap",
  ] },
  { version: "2.0.0", date: "17.08.2026", changes: [
    "Первый крупный выпуск с YClients на всех точках",
    "Предупреждение, если новый скан начат без смены пациента",
    "Центр: перенос скана другому пациенту",
  ] },
  { version: "1.0.33–1.0.38", date: "11–13.08.2026", changes: [
    "Интеграция с YClients: поиск пациента по телефону, выбор записи, сверка пациентов на центре",
    "Вкладка «Журнал» с записями YClients в виде календаря",
    "Ссылка на отчёт автоматически уходит в карточку клиента YClients",
    "Каталог товаров по точкам, синхронизация при появлении сети, автовыход через 2 часа",
    "Публичные ссылки на отчёты, смена пароля пользователя",
  ] },
  { version: "1.0.27–1.0.32", date: "05.08.2026", changes: [
    "Скрытые заметки к пациенту и обследованию",
    "Скан жёстко привязан к пациенту, быстрый поиск по всей базе",
    "Валик и линии в отчёте, покупки только из каталога, новый вид жалоб",
    "Драйвер сканера убран из установки",
  ] },
  { version: "1.0.20–1.0.26", date: "03.08.2026", changes: [
    "Исправлен поворот скана, формула размера в мм → российский размер",
    "Валики с реальными размерами длина × ширина",
    "Сохранённый скан можно открыть на редактирование",
    "Кнопка «Сообщить о проблеме»",
    "Поиск по телефону и имени, покупки из каталога, фильтр по дате обследования",
    "Правка синхронизированного пациента больше не создаёт дубль на центре",
  ] },
  { version: "1.0.13–1.0.19", date: "23–24.07.2026", changes: [
    "Надёжное автоопределение стоп, вертикальная ориентация по умолчанию",
    "Автообновление: периодическая проверка и повтор при сбое загрузки",
    "Валик поворачивается по метатарзальной линии",
  ] },
  { version: "1.0.6–1.0.12", date: "21.07.2026", changes: [
    "Конфигурация полей, общие пациенты и синхронизация между точками, раздел «Упражнения»",
    "Автоопределение стоп, форма валика, поворот скана на 90°",
    "Удаление только с центра, стельки и сопутствующие товары раздельно, группы товаров до 3 уровней",
  ] },
  { version: "1.0", date: "17.06–21.07.2026", changes: [
    "Первая версия ScanApp: сканирование, пациенты, отчёты",
    "Программа для Windows, синхронизация точек с центром, фото к обследованиям",
  ] },
];

const VISIBLE_VERSIONS = 5;

export default function RoadmapPage() {
  const [showAllVersions, setShowAllVersions] = useState(false);
  const versions = showAllVersions ? VERSIONS : VERSIONS.slice(0, VISIBLE_VERSIONS);
  return (
    <div className="flex-1 overflow-y-auto p-8">
      <div className="max-w-4xl mx-auto">
      <div className="flex items-center gap-3 mb-1">
        <div className="flex items-center justify-center w-10 h-10 rounded-2xl bg-slate-900">
          <Rocket className="h-5 w-5 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900">Roadmap</h1>
      </div>
      <p className="text-sm text-slate-400 mb-10 ml-[52px]">Что уже выпущено и что будет дальше</p>

      <div className="relative flex flex-col gap-6">
        {/* Вертикальная линия таймлайна */}
        <div className="absolute left-[27px] top-3 bottom-3 w-px bg-slate-200" aria-hidden="true" />

        {ITEMS.map((item) => {
          const c = COLOR_CLASSES[item.color];
          const Icon = item.icon;
          return (
            <div key={item.title} className="relative flex gap-5">
              <div className="relative z-10 flex-shrink-0">
                <div className={`flex items-center justify-center w-14 h-14 rounded-2xl ${c.bg} ring-8 ring-white`}>
                  <Icon className={`h-6 w-6 ${c.text}`} />
                </div>
              </div>

              <div className="flex-1 rounded-2xl bg-white p-5 min-w-0" style={cardShadow}>
                <div className="flex items-center justify-between gap-3 mb-1 flex-wrap">
                  <h2 className="text-base font-bold text-slate-900">{item.title}</h2>
                  <span className={`text-[10px] font-bold uppercase tracking-wide px-2 py-1 rounded-full ${c.bg} ${c.text}`}>
                    {item.tagline}
                  </span>
                </div>
                <p className="text-sm text-slate-600 leading-relaxed mb-3">{item.description}</p>
                <ul className="flex flex-col gap-1.5">
                  {item.points.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-[13px] text-slate-500">
                      <span className={`mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0 ${c.dot}`} />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>

      <h2 className="text-lg font-bold text-slate-900 mt-14 mb-1">История версий</h2>
      <p className="text-sm text-slate-400 mb-5">Что появилось в каждой версии программы</p>
      <div className="rounded-2xl bg-white divide-y divide-slate-100" style={cardShadow}>
        {versions.map((v) => (
          <div key={v.version} className="flex flex-col sm:flex-row gap-1 sm:gap-6 p-5">
            <div className="sm:w-36 flex-shrink-0">
              <div className="text-sm font-bold text-slate-900">{v.version}</div>
              {v.date && <div className="text-xs text-slate-400">{v.date}</div>}
              {v.note && (
                <span className="inline-block mt-1 text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full bg-slate-100 text-slate-500">
                  {v.note}
                </span>
              )}
            </div>
            <ul className="flex flex-col gap-1.5 min-w-0">
              {v.changes.map((change) => (
                <li key={change} className="flex items-start gap-2 text-[13px] text-slate-600">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0 bg-slate-300" />
                  {change}
                </li>
              ))}
            </ul>
          </div>
        ))}
        {VERSIONS.length > VISIBLE_VERSIONS && (
          <button
            type="button"
            onClick={() => setShowAllVersions((v) => !v)}
            className="w-full flex items-center justify-center gap-1.5 p-4 text-sm font-medium text-slate-500 hover:text-slate-900 rounded-b-2xl"
          >
            {showAllVersions ? "Свернуть" : `Показать все версии (${VERSIONS.length})`}
            <ChevronDown className={`h-4 w-4 transition-transform ${showAllVersions ? "rotate-180" : ""}`} />
          </button>
        )}
      </div>
      </div>
    </div>
  );
}
